import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "circle-check, check radio, circle, checkbox, check, checkmark, confirm" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99998 1.33325C4.31808 1.33325 1.33331 4.31802 1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666C11.6819 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6819 1.33325 7.99998 1.33325ZM10.516 6.75543C10.7491 6.47047 10.7071 6.05045 10.4221 5.8173C10.1372 5.58415 9.71716 5.62615 9.48401 5.91111L6.95049 9.00764L6.13805 8.1952C5.8777 7.93485 5.45559 7.93485 5.19524 8.1952C4.93489 8.45555 4.93489 8.87766 5.19524 9.13801L6.52858 10.4713C6.66176 10.6045 6.84507 10.6752 7.03319 10.6658C7.22131 10.6564 7.39668 10.5679 7.51595 10.4221L10.516 6.75543Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }